// When the cursor is in an input field nothing is touched: the browser's own
// letter-by-letter undo is the one expected there. Our history answers
// everywhere else.
import { useEffect } from "react"

const EDITABLE = new Set(["INPUT", "TEXTAREA", "SELECT"])

export const isEditingText = target => {
  if (!target) return false
  if (EDITABLE.has(target.tagName)) return true
  return !!target.closest?.("[contenteditable='true'], .ql-editor")
}

const useHistoryShortcuts = dispatch => {
  useEffect(() => {
    const onKey = event => {
      const key = event.key?.toLowerCase()
      if (key !== "z" && key !== "y") return
      if (!(event.metaKey || event.ctrlKey)) return
      if (isEditingText(event.target)) return

      const redo = key === "y" || event.shiftKey
      event.preventDefault()
      dispatch({ type: redo ? "REDO" : "UNDO" })
    }

    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [dispatch])
}

export default useHistoryShortcuts
